/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { oneOfType, string, number, bool, object, array } from 'prop-types';

const renderValue = (value, list) => {
  let result = null;

  for (let key in list) {
    if (key === value) {
      return list[key];
    }

    if (list[key] instanceof Object) {
      result = renderValue(value, list[key]);

      if (result) break;
    }
  }

  return result;
};

/**
 * This is the MapProps component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const MapProps = ({ value, list }) => {
  const result = renderValue(value, list) || value;
  return <span>{result}</span>;
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
MapProps.propTypes = {
  value: oneOfType([string, number, bool]).isRequired,
  list: oneOfType([object, array]).isRequired,
};

export default MapProps;
